import { Inject, Injectable, InjectionToken } from '@angular/core';
import { LOCAL_STORAGE_KEY, SESSION_STORAGE_KEY } from '@core/configs';

export const keyTriggerSession = {
  setToken: 'set_token',
};

export const LOCAL_STORAGE = new InjectionToken<Storage>('Local Storage', {
  providedIn: 'root',
  factory: () => localStorage,
});

@Injectable({
  providedIn: 'root',
})
export class LocalStorageService {
  constructor(
    @Inject(LOCAL_STORAGE) private storage: Storage,
  ) { }

  getKeys(): string[] {
    return Object.keys(this.storage);
  }

  getItem<T = any>(key: string): T {
    const value = this.storage.getItem(key);
    try {
      return JSON.parse(value || "");
    } catch (e) {
      return value as unknown as T;
    }
  }
  
  getSettingDialog<T = any>(key: string): T {
    let office = sessionStorage.getItem(SESSION_STORAGE_KEY.selectedOfficeIdentity) || "";
    let officeCd = office ? JSON.parse(office).officeCd : "";
    let value = this.storage.getItem(key) || "";
    value = JSON.parse(value)[officeCd];
    try {
      return JSON.parse(value || "");
    } catch (e) {
      return value as unknown as T;
    }
  }

  setItem<T>(key: string, value: T): void {
    if (value == null) {
      this.removeItem(key);
      return;
    }
    this.storage.setItem(key, JSON.stringify(value));
  }

  removeItem(key: string): void {
    this.storage.removeItem(key);
  }


  clear(exclude: string[] = []) {
    this.getKeys().forEach(key => {
      if (!exclude.includes(key)) {
        this.removeItem(key);
      }
    });
  }

  hasKey(key: string): boolean {
    return this.getKeys().includes(key);
  }

  public setSaucerLogs(logs: any) {
    localStorage.setItem(LOCAL_STORAGE_KEY.saucerLogs, JSON.stringify(logs));
  }

  public getSaucerLogs() {
    return JSON.parse(localStorage.getItem(LOCAL_STORAGE_KEY.saucerLogs) || "[]");
  }

  public clearSaucerLogs() {
    localStorage.removeItem(LOCAL_STORAGE_KEY.saucerLogs);
  }
}
